import React, {isValidElement} from 'react';

import {convertNodeToElement} from 'react-html-parser';

import {StyledDiffedImageContainerDiv} from 'app/procedures/styles';

import {EmbedlyVideoEmbedProcessor} from './EmbedlyVideoEmbed/EmbedlyVideoEmbedProcessor';
import {ProcessorType} from './node-processors-types';
import {SweetVideoEmbedProcessor} from './SweetVideoEmbed/SweetVideoEmbedProcessor';

export const WrapVideoInDiffMarksProcessor: ProcessorType = {
  tag: 'a',
  condition: (node) =>
    (EmbedlyVideoEmbedProcessor.condition(node) ||
      SweetVideoEmbedProcessor.condition(node)) &&
    node.attribs['data-diff-node'] != null,
  processor: (node, index, transform) => {
    const diffOperation = node.attribs['data-diff-node'];
    delete node.attribs['data-diff-node'];
    const processedNode = transform(node, index);

    // transform can return a react element or a node but we need make
    // sure its a react element
    let reactElement = isValidElement(processedNode)
      ? processedNode
      : convertNodeToElement(processedNode, index, transform);

    if (diffOperation === 'ins' || diffOperation === 'del') {
      reactElement = (
        <StyledDiffedImageContainerDiv key={index} className={diffOperation}>
          {reactElement}
        </StyledDiffedImageContainerDiv>
      );
    }

    return [null, reactElement];
  },
};
